"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLICK_ORDER_KEY = exports.VISIBLE_TIME_KEY = exports.SESSION_VALID_TIME = exports.OTHER_WEB_APP_ID = exports.IOS_APP_ID = exports.ANDROID_APP_ID = exports.ROUTES_INFO_KEY = exports.ROUTES_STORE_NAME = exports.SESSION_ID_KEY = exports.INITIAL_UPLOAD_TIMEOUT = exports.UPLOAD_INTERVAL = void 0;
exports.UPLOAD_INTERVAL = 2 * 1000;
exports.INITIAL_UPLOAD_TIMEOUT = 3 * 1000;
// session id 存储 key
exports.SESSION_ID_KEY = "si";
exports.ROUTES_STORE_NAME = "routeshistory";
exports.ROUTES_INFO_KEY = "info";
exports.ANDROID_APP_ID = "002";
exports.IOS_APP_ID = "003";
exports.OTHER_WEB_APP_ID = "001";
exports.SESSION_VALID_TIME = 30 * 60 * 1000; // 半小时
exports.VISIBLE_TIME_KEY = "visibleTime";
exports.CLICK_ORDER_KEY = "co";
